import { landingTemplate } from "./app/templates";
import "./styles/main.css";

const app = document.querySelector<HTMLElement>("#app");
if (!app) throw new Error("APP_ROOT_MISSING");

app.innerHTML = landingTemplate();

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => void navigator.serviceWorker.register("/sw.js"));
}
